import React, { useImperativeHandle } from 'react';
import ReactGoogleAutocomplete from 'react-google-autocomplete';

import { InScreenModal, NavBar } from '../../components';

import GLOBAL from '../../configs/config_global';
import PropTypes from 'prop-types';

const AddressSearchModal = React.forwardRef((props, ref) => {
    const { onPlaceSelected = () => {} } = props;

    const [visible, setVisible] = React.useState(false);

    const showModal = () => setVisible(true);
    const hideModal = () => setVisible(false);

    useImperativeHandle(ref, () => ({ showModal, hideModal }), []);

    return(
        <InScreenModal visible={visible}>
            {/* Nav Bar */}
            <NavBar
                title={'Address Search'}
                subTitle={'Powered by Google'}
                hideBorder={true}
                leftButtonOnPress={() => hideModal()}
            />

            {/* Autocomplete */}
            <ReactGoogleAutocomplete
                apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
                onPlaceSelected={(place) => {
                    onPlaceSelected(place);
                    hideModal();
                }}
                options={{
                    componentRestrictions: { country: 'us' },
                    types: ['geocode']
                }}
                style={{ fontSize: 18, outlineStyle: 'none', height: 48, boxShadow: 'none', borderRadius: 8, borderColor: GLOBAL.COLOR.TEXT_LIGHT_GRAY, marginLeft: 20, marginRight: 20, paddingLeft: 16, paddingRight: 16 }}
            />
        </InScreenModal>
    )
});

AddressSearchModal.propTypes = {
    onPlaceSelected: PropTypes.func
}

AddressSearchModal.defaultProps = {
    onPlaceSelected: () => {}
}

export default AddressSearchModal;
